const defaultPriceOptions = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  currency: 'USD'
};

export const formatPrice = (price = 0, options = {}, locale = 'en-US') => {
  if (typeof price !== 'number') {
    return '0.00';
  }

  const formatOptions = {
    ...defaultPriceOptions,
    ...options
  };

  let style = formatOptions?.style;
  if (!style) {
    if (formatOptions?.currency) {
      style = 'currency';
    } else {
      style = 'decimal';
    }
  }

  return price.toLocaleString(locale, {
    ...formatOptions,
    style
  });
};

export const formatBasicCurrency = (amount = 0, currency = 'USD') => {
  const price = Number(amount) / 100
  return `${price.toFixed(price % 1 === 0 ? 0 : 2)} ${currency}`;
};

export const getCurrencyStep = (currency) => {
  if (!currency) return 0.01;
  const numberFormat = new Intl.NumberFormat('en-US', { style: 'currency', currency });
  const numDecimals = numberFormat.formatToParts(1).find((part) => part.type === 'fraction')?.value.length ?? 0;
  const step = Math.pow(10, -numDecimals);
  return step;
};
